import * as React from 'react'
import { Box, Modal, Typography as MIUTypography } from '@mui/material'
import { styled } from '@mui/material/styles'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 530,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '25px',
  pb: 1,
  filter:
    'drop-shadow(0px 15px 12px rgba(0, 0, 0, 0.22)) drop-shadow(0px 19px 38px rgba(0, 0, 0, 0.3))',
  textAlign: 'justify',
  borderRadius: '14px',
}

const Typography = styled(MIUTypography)(props => ({
  fontFamily: 'var(--font-family)',
  fontStyle: 'normal',
  fontSize: props.istitle ? '1.2em' : '0.9em',
  fontWeight: props.istitle ? 500 : 400,
  lineHeight: '24px',
  color: props.istitle ? '#1B1C37' : '#6A6A6A',
}))

const AddRecordsModal = ({ open, title, description, children }) => {
  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-creation-title"
        aria-describedby="modal-creation-modal-description"
        componentsProps={{ backdrop: { sx: { backdropFilter: 'blur(2px)' } } }}
        disableEscapeKeyDown>
        <Box sx={style}>
          <Typography istitle={1} id="modal-modal-title" variant="h6" component="h2">
            {title}
          </Typography>
          <Typography id="modal-modal-description" sx={{ my: 1 }}>
            {description}
          </Typography>
          {children}
        </Box>
      </Modal>
    </div>
  )
}
export default AddRecordsModal
